import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "main-content-container" };
const _hoisted_2 = { class: "card bg-white border-0 rounded-10 mb-30 p-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center justify-content-between mb-25" };
const _hoisted_4 = { class: "d-flex align-items-center gap-3" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "d-flex align-items-center gap-2" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table v-middle mb-0" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "fw-bold text-dark" };
const _hoisted_12 = { class: "text-muted" };
const _hoisted_13 = ["title"];
const _hoisted_14 = { class: "text-end" };
const _hoisted_15 = ["href"];
const _hoisted_16 = {
    key: 1,
    class: "text-muted small"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BreadCrumb, { PageTitle: 'Historique des Clôtures' }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filters.restaurantId) = $event)),
                        class: "form-select w-auto",
                        onChange: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.fetchClosures && _ctx.fetchClosures(...args)))
                    }, [
                        _cache[7] || (_cache[7] = _createElementVNode("option", { value: "" }, "Tous les restaurants", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (res) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: res.id,
                                value: res.id
                            }, _toDisplayString(res.name), 9, _hoisted_5));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, _ctx.filters.restaurantId]
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.filters.startDate) = $event)),
                            class: "form-control w-auto",
                            onChange: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.fetchClosures && _ctx.fetchClosures(...args)))
                        }, null, 544), [
                            [_vModelText, _ctx.filters.startDate]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "au", -1)),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.filters.endDate) = $event)),
                            class: "form-control w-auto",
                            onChange: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => (_ctx.fetchClosures && _ctx.fetchClosures(...args)))
                        }, null, 544), [
                            [_vModelText, _ctx.filters.endDate]
                        ])
                    ])
                ]),
                _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] =
                        //@ts-ignore
                        (...args) => (_ctx.fetchClosures && _ctx.fetchClosures(...args))),
                    class: "btn btn-outline-primary"
                }, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("i", { class: "ph-duotone ph-arrows-clockwise me-1" }, null, -1),
                        _createTextVNode(" Actualiser ", -1)
                    ]))])
            ]),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                    _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Date"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Restaurant"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Responsable"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Théorique"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Réel"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Écart"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase" }, "Justification"),
                            _createElementVNode("th", { class: "text-muted fw-medium text-uppercase text-end" }, "Rapport")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[10] || (_cache[10] = [
                                    _createElementVNode("td", {
                                        colspan: "8",
                                        class: "text-center py-5"
                                    }, [
                                        _createElementVNode("div", {
                                            class: "spinner-border text-primary",
                                            role: "status"
                                        }),
                                        _createElementVNode("div", { class: "mt-2 text-muted" }, "Chargement de l'historique...")
                                    ], -1)
                                ]))]))
                            : (_ctx.closures.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("td", {
                                            colspan: "8",
                                            class: "text-center py-5 text-muted"
                                        }, " Aucune clôture trouvée pour cette période. ", -1)
                                    ]))]))
                                : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.closures, (closure) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: closure.id
                            }, [
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDate(closure.date)), 1),
                                    _createElementVNode("small", _hoisted_12, _toDisplayString(_ctx.formatTime(closure.createdAt)), 1)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(closure.restaurant?.name || 'N/A'), 1),
                                _createElementVNode("td", null, _toDisplayString(closure.user?.first_name) + " " + _toDisplayString(closure.user?.last_name), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(closure.theoreticalTotal)), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.formatCurrency(closure.actualTotal)), 1),
                                _createElementVNode("td", null, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(['badge rounded-pill', _ctx.getGapClass(closure.gap)])
                                    }, _toDisplayString(_ctx.formatCurrency(closure.gap)), 3)
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", {
                                        class: "text-truncate",
                                        style: { "max-width": "150px" },
                                        title: closure.notes
                                    }, _toDisplayString(closure.notes || '-'), 9, _hoisted_13)
                                ]),
                                _createElementVNode("td", _hoisted_14, [
                                    (closure.pdfUrl)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: closure.pdfUrl,
                                            target: "_blank",
                                            class: "btn btn-sm btn-light-danger d-inline-flex align-items-center"
                                        }, [...(_cache[12] || (_cache[12] = [
                                                _createElementVNode("i", { class: "ph-bold ph-file-pdf me-1 fs-5" }, null, -1),
                                                _createTextVNode(" PDF ", -1)
                                            ]))], 8, _hoisted_15))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_16, "Indisponible"))
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ])
        ])
    ]));
}
